<template>
  <div class="container-fluid">
    <splitpanes class="default-theme" :style="{height: splitPaneHeight}" :size="10">
      <pane max-size="25">
        <div class="row" style="margin: 5px;">
          <div class="col" style="text-align: center;">
            <b-button-group>
              <b-button
                style="font-size: 12px;"
                variant="success"
                @click="selectedPeriodTimesToday"
              >{{ periodOfTimeTodayLabel }}</b-button>
              <b-button
                style="font-size: 12px;"
                variant="success"
                @click="selectedPeriodTimesYesterday"
              >{{ periodOfTimeYesterdayLabel }}</b-button>
              <b-button
                style="font-size: 12px;"
                variant="success"
                @click="selectedPeriodTimesLastWeek"
              >{{ periodOfTimeLastWeekLabel }}</b-button>
              <b-button
                style="font-size: 12px;"
                variant="success"
                @click="selectedPeriodTimesLastMonth"
              >{{ periodOfTimeLastMonthLabel }}</b-button>
            </b-button-group>
          </div>
        </div>

        <div class="row no-gutters">
          <div class="col-2" style="margin: 5px; font-size: 12px;">
            <label>{{ beginPeriodLabel }}:</label>
          </div>
          <div class="col-5" style="margin: 5px;">
            <input type="date" style="font-size: 12px; width: 120px;" v-model="beginDate" />
          </div>
          <div class="col-3" style="margin: 5px;">
            <input type="time" style="font-size: 12px;" v-model="beginTime" />
          </div>
        </div>

        <div class="row no-gutters">
          <div class="col-2" style="margin: 5px; font-size: 12px;">
            <label>{{ endPeriodLabel }}:</label>&Tab;
          </div>
          <div class="col-5" style="margin: 5px;">
            <input type="date" style="font-size: 12px; width: 120px;" v-model="endDate" />&Tab;
          </div>
          <div class="col-3" style="margin: 5px;">
            <input type="time" style="font-size: 12px;" v-model="endTime" />
          </div>
        </div>

        <div class="row" style="margin: 5px;">
          <b-button
            style="font-size: 12px;"
            class="btn-block"
            variant="success"
            @click="getTaxReports"
          >{{ getReportsButton }}</b-button>
          <b-button
            style="font-size: 12px;"
            class="btn-block"
            variant="success"
            @click="createTaxReport"
          >{{ newReportButton }}</b-button>
        </div>
      </pane>
      <pane>
        <div class="text-center" v-show="isTaxReportLoading">
          <div>
            <b-spinner label="Spinning" variant="success" style="width: 10rem; height: 10rem;"></b-spinner>
          </div>
        </div>
        <div class="row" v-if="taxReports.data != null">
          <div class="col-12">
            <b-table
              class="textMiddle"
              small
              hover
              bordered
              show-empty
              responsive
              head-variant="light"
              :items="taxReports.data"
              :fields="taxReportsFields"
              v-bind:emptyText="reportNoData"
              sticky-header="500px"
            >
              <template v-slot:empty="scope">
                <div class="row justify-content-md-center">
                  <h5>{{ scope.emptyText }}</h5>
                </div>
              </template>

              <template v-slot:cell(showDetails)="row">
                <b-button
                  size="sm"
                  @click="row.toggleDetails"
                  class="mr-2"
                  style="font-size: 12px;"
                >{{ row.detailsShowing ? hideLabel : showLabel }}</b-button>
              </template>

              <template v-slot:row-details="row">
                <b-table
                  class="textMiddle"
                  small
                  hover
                  bordered
                  responsive
                  head-variant="light"
                  :items="row.item.fuelTanks"
                  v-bind:fields="taxReportsDetailsFields"
                >
                  <template v-slot:cell(isActive)="row">
                    <b-form-checkbox v-model="row.item.isActive" />
                  </template>
                </b-table>
              </template>
            </b-table>
          </div>
        </div>
      </pane>
    </splitpanes>

    <b-modal
      ref="create-tax-report-modal"
      size="xl"
      v-bind:title="newTaxReport"
      @ok="createTaxReportModalOk"
    >
      <b-container fluid>
        <b-row>
          <div style="font-size: 14px;">{{ reportDate }}: {{reportedOnFormatted}}</div>&Tab;
        </b-row>
        <b-row>
          <b-table
            class="textMiddle"
            style="font-size: 12px;"
            small
            hover
            bordered
            responsive
            head-variant="light"
            :items="taxReport.fuelTanks"
            v-bind:fields="taxReportsCreateFields"
          >
            <template v-slot:cell(isActive)="row">
              <b-form-checkbox v-model="row.item.isActive" />
            </template>
            <template v-slot:cell(beginFuelVolumeReport)="row">
              <b-form-input
                type="number"
                min="0"
                v-model="row.item.beginFuelVolumeReport"
                style="font-size: 12px;"
              />
            </template>
            <template v-slot:cell(endFuelVolumeReport)="row">
              <b-form-input
                type="number"
                min="0"
                v-model="row.item.endFuelVolumeReport"
                style="font-size: 12px;"
              />
            </template>
          </b-table>
        </b-row>
      </b-container>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="light" style="font-size: 12px;" @click="cancel()">Cancel</b-button>
        <b-button variant="success" style="font-size: 12px;" @click="ok()">OK</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import { taxReportService } from "../../services";
import { utilsService } from "../../services";

export default {
  name: "TaxReports",
  components: { Splitpanes, Pane },
  props: {
    fuelTanks: Array
  },
  data() {
    return {
      beginDate: null,
      beginTime: null,
      endDate: null,
      endTime: null,
      isValidationError: false,
      validationError: null,
      taxReports: {
        data: null
      },
      taxReport: {
        reportedOn: null,
        fuelTanks: []
      },
      isTaxReportLoading: false
    };
  },
  computed: {
    splitPaneHeight() {
      const LEFT_TOP_POSITION_Y = 50;

      return `${document.documentElement.clientHeight - LEFT_TOP_POSITION_Y}px`;
    },
    reportedOnFormatted() {
      const date = new Date(this.taxReport.reportedOn * 1000);

      return utilsService.formatDateTime(date, "yyyyMMdd");
    },
    beginPeriodLabel() {
      return this.$store.state.localization.data.common.beginPeriodLabel;
    },
    endPeriodLabel() {
      return this.$store.state.localization.data.common.endPeriodLabel;
    },
    reportNoData() {
      return this.$store.state.localization.data.common.table.noData;
    },
    newReportButton() {
      return this.$store.state.localization.data.mainPage.taxReports
        .newReportButton;
    },
    getReportsButton() {
      return this.$store.state.localization.data.mainPage.taxReports
        .getReportsButton;
    },
    hideLabel() {
      return this.$store.state.localization.data.common.table.hide;
    },
    showLabel() {
      return this.$store.state.localization.data.common.table.show;
    },
    periodOfTimeTodayLabel() {
      return this.$store.state.localization.data.common.periodTimesOptions
        .today;
    },
    periodOfTimeYesterdayLabel() {
      return this.$store.state.localization.data.common.periodTimesOptions
        .yesterday;
    },
    periodOfTimeLastWeekLabel() {
      return this.$store.state.localization.data.common.periodTimesOptions
        .lastWeek;
    },
    periodOfTimeLastMonthLabel() {
      return this.$store.state.localization.data.common.periodTimesOptions
        .lastMonth;
    },
    taxReportsFields() {
      const taxReportsFields = [];

      const columns = this.$store.state.localization.data.mainPage.taxReports
        .tableColumns;

      for (let key in columns) {
        taxReportsFields.push({
          key: key,
          label: columns[key],
          thClass: "textMiddle",
        });
      }

      return taxReportsFields;
    },
    taxReportsCreateFields() {
      const taxReportsCreateFields = [];

      const columns = this.$store.state.localization.data.mainPage.taxReports
        .tableDetailsColumns;

      for (let key in columns) {
        taxReportsCreateFields.push({
          key: key,
          label: columns[key],
          thClass: "textMiddle",
        });
      }

      return taxReportsCreateFields;
    },
    taxReportsDetailsFields() {
      const taxReportsDetailsFields = [];

      const columns = this.$store.state.localization.data.mainPage.taxReports
        .tableDetailsColumns;

      for (let key in columns) {
        if (key != "isActive") {
          taxReportsDetailsFields.push({
            key: key,
            label: columns[key],
            thClass: "textMiddle",
          });
        }
      }

      return taxReportsDetailsFields;
    },
    newTaxReport() {
      return this.$store.state.localization.data.mainPage.taxReports
        .newTaxReport;
    },
    reportDate() {
      return this.$store.state.localization.data.mainPage.taxReports.reportDate;
    },
  },
  async created() {
    const today = new Date();

    const todayString = today.toISOString().substr(0, 10);

    this.beginDate = todayString;
    this.beginTime = "00:00:00";

    this.endDate = todayString;
    this.endTime = "23:59:00";
  },
  methods: {
    async getTaxReports() {
      this.taxReports.data = null;

      const beginDateTime = new Date(this.beginDate + " " + this.beginTime);

      if (isNaN(beginDateTime)) {
        this.validationError = this.$store.state.localization.data.common.validations.beginPeriod;
        this.isValidationError = true;

        return;
      }

      const endDateTime = new Date(this.endDate + " " + this.endTime);

      if (isNaN(endDateTime)) {
        this.validationError = this.$store.state.localization.data.common.validations.endPeriod;
        this.isValidationError = true;

        return;
      }

      if (beginDateTime > endDateTime) {
        this.validationError = this.$store.state.localization.data.common.validations.endPeriodInvalid;
        this.isValidationError = true;

        return;
      }

      this.isTaxReportLoading = true;

      const taxReportsResponse = await taxReportService.getTaxReports(
        beginDateTime,
        endDateTime
      );

      if (!taxReportsResponse.isSuccess) {
        //TODO: added error handling
        this.validationError = taxReportsResponse.data;
        this.isValidationError = true;

        return;
      }

      this.isTaxReportLoading = false;

      this.taxReports.data = [];

      for (let i = 0; i < taxReportsResponse.data.reports.length; i++) {
        const reportedOn = new Date(
          taxReportsResponse.data.reports[i].reportedOn * 1000
        );

        const createdOn = new Date(
          taxReportsResponse.data.reports[i].createdOn * 1000
        );

        const row = {
          reportedOn: utilsService.formatDateTime(reportedOn, utilsService.DATE_TIME_FORMAT2),
          createdOn: utilsService.formatDateTime(createdOn, utilsService.DATE_TIME_FORMAT),
          fuelTanks: [],
        };

        const fuelTanks = taxReportsResponse.data.reports[i].fuelTanks;

        for (let j = 0; j < fuelTanks.length; j++) {
          const fuelTank = this.fuelTanks.find(
            (item) =>
              item.vehicleId == fuelTanks[j].vehicleId &&
              item.fuelTankId == fuelTanks[j].fuelTankId
          );

          row.fuelTanks.push({
            isActive: fuelTanks[j].isActive,
            companyName: fuelTank.companyName,
            depoName: fuelTank.depoName,
            fuelTankName: fuelTank.fuelTankName,
            beginFuelVolumeSensor: fuelTanks[j].beginFuelVolumeSensor,
            endFuelVolumeSensor: fuelTanks[j].endFuelVolumeSensor,
            beginFuelVolumeReport: fuelTanks[j].beginFuelVolumeReport,
            endFuelVolumeReport: fuelTanks[j].endFuelVolumeReport,
          });
        }

        row.fuelTanks.sort(this.sortFuelTanks);

        this.taxReports.data.push(row);
      }
    },
    selectedPeriodTimesToday() {
      const today = new Date();

      const beginDateString = new Date(
        today.getTime() - today.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = beginDateString;
      this.endTime = "23:59:00";
    },
    selectedPeriodTimesYesterday() {
      const today = new Date();

      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);

      const beginDateString = new Date(
        yesterday.getTime() - yesterday.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = beginDateString;
      this.endTime = "23:59:00";
    },
    selectedPeriodTimesLastWeek() {
      const today = new Date();

      const lastWeek = new Date(today);
      lastWeek.setDate(today.getDate() - 7);

      const beginDateString = new Date(
        lastWeek.getTime() - lastWeek.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      const endDateString = new Date(
        today.getTime() - today.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = endDateString;
      this.endTime = "23:59:00";
    },
    selectedPeriodTimesLastMonth() {
      const today = new Date();

      const lastMonth = new Date(today);
      lastMonth.setDate(today.getDate() - 30);

      const beginDateString = new Date(
        lastMonth.getTime() - lastMonth.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      const endDateString = new Date(
        today.getTime() - today.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = endDateString;
      this.endTime = "23:59:00";
    },
    async createTaxReport() {
      this.taxReport.fuelTanks = [];

      this.isTaxReportLoading = true;

      const taxReportResponse = await taxReportService.getTaxReport();

      this.isTaxReportLoading = false;

      if (!taxReportResponse.isSuccess) {
        //TODO: added error handling
        return;
      }

      this.taxReport.reportedOn = taxReportResponse.data.report.reportedOn;
      this.taxReport.signature = taxReportResponse.data.report.signature;

      const fuelTanks = taxReportResponse.data.report.fuelTanks;

      for (let i = 0; i < fuelTanks.length; i++) {
        const fuelTank = this.fuelTanks.find(
          (item) =>
            item.vehicleId == fuelTanks[i].vehicleId &&
            item.fuelTankId == fuelTanks[i].fuelTankId
        );

        this.taxReport.fuelTanks.push({
          isActive: false,
          companyName: fuelTank.companyName,
          depoName: fuelTank.depoName,
          fuelTankName: fuelTank.fuelTankName,
          vehicleId: fuelTanks[i].vehicleId,
          fuelTankId: fuelTanks[i].fuelTankId,
          beginFuelVolumeSensor: fuelTanks[i].beginFuelVolumeSensor,
          endFuelVolumeSensor: fuelTanks[i].endFuelVolumeSensor,
          beginFuelVolumeReport: fuelTanks[i].beginFuelVolumeReport,
          endFuelVolumeReport: fuelTanks[i].endFuelVolumeReport,
        });
      }

      this.taxReport.fuelTanks.sort(this.sortFuelTanks);

      this.$refs["create-tax-report-modal"].show();
    },
    async createTaxReportModalOk() {
      const taxReport = {
        reportedOn: this.taxReport.reportedOn,
        signature: this.taxReport.signature,
        fuelTanks: [],
      };

      for (let i = 0; i < this.taxReport.fuelTanks.length; i++) {
        taxReport.fuelTanks.push({
          isActive: this.taxReport.fuelTanks[i].isActive,
          fuelTankName: this.taxReport.fuelTanks[i].fuelTankName,
          vehicleId: this.taxReport.fuelTanks[i].vehicleId,
          fuelTankId: this.taxReport.fuelTanks[i].fuelTankId,
          beginFuelVolumeSensor: this.taxReport.fuelTanks[i]
            .beginFuelVolumeSensor,
          endFuelVolumeSensor: this.taxReport.fuelTanks[i].endFuelVolumeSensor,
          beginFuelVolumeReport: parseInt(
            this.taxReport.fuelTanks[i].beginFuelVolumeReport
          ),
          endFuelVolumeReport: parseInt(
            this.taxReport.fuelTanks[i].endFuelVolumeReport
          ),
        });
      }

      this.isTaxReportLoading = true;

      const createdTaxReportResponse = await taxReportService.createTaxReport(
        taxReport
      );

      this.isTaxReportLoading = false;

      if (!createdTaxReportResponse.isSuccess) {
        //TODO: added error handling
        return;
      }

      const lastTaxReport = this.taxReports.data[
        this.taxReports.data.length - 1
      ];

      for (let i = 0; i < lastTaxReport.fuelTanks.length; i++) {
        lastTaxReport.fuelTanks[i].beginFuelVolumeReport =
          taxReport.fuelTanks[i].beginFuelVolumeReport;
        lastTaxReport.fuelTanks[i].endFuelVolumeReport =
          taxReport.fuelTanks[i].endFuelVolumeReport;
      }
    },
    sortFuelTanks(a, b) {
      const companyNameA = a.companyName.toUpperCase();
      const companyNameB = b.companyName.toUpperCase();

      if (companyNameA != companyNameB) {
        return companyNameA > companyNameB ? 1 : -1;
      }

      const depoNameA = a.depoName.toUpperCase();
      const depoNameB = b.depoName.toUpperCase();

      if (depoNameA != depoNameB) {
        return depoNameA > depoNameB ? 1 : -1;
      }

      const fuelTankNameA = a.fuelTankName.toUpperCase();
      const fuelTankNameB = b.fuelTankName.toUpperCase();

      return fuelTankNameA > fuelTankNameB ? 1 : -1;
    },
  },
};
</script>

<style>
.textMiddle {
  vertical-align: middle !important;
  text-align: center !important;
  min-width: 20px !important;
}
</style>

